import Swal from "sweetalert2";
import { URL } from "./Accesos";

const post = (endpoint, object) => {
  return new Promise(async (res, req) => {
    const token = localStorage.getItem("HumayaDigital-Token");
    await fetch(`${URL}${endpoint}`, {
      method: "POST",
      body: JSON.stringify(object),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then(async (result) => {
        if (result.status === 401) {
          swalWithBootstrapButtons
            .fire({
              icon: "warning",
              title: "SESION",
              text: "LA SESION A CADUCADO, FAVOR DE INICIAR SESION DE NUEVO",
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: "OK",
              reverseButtons: false,
            })
            .then(() => {
              window.location = "/auth/login";
            });
        } else {
          const body = await result.json();
          if (result.ok) {
            res(body);
          } else {
            req(body);
          }
        }
      })
      .catch(async (error) => {
        req(await error);
      });
  });
};
const postToken = (endpoint, object, token) => {
  return new Promise(async (res, req) => {
    await fetch(`${URL}${endpoint}`, {
      method: "POST",
      body: JSON.stringify(object),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then(async (result) => {
        if (result.status === 401) {
          swalWithBootstrapButtons
            .fire({
              icon: "warning",
              title: "SESION",
              text: "LA SESION A CADUCADO, FAVOR DE INICIAR SESION DE NUEVO",
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: "OK",
              reverseButtons: false,
            })
            .then(() => {
              window.location = "/auth/login";
            });
        } else {
          const body = await result.json();
          if (result.ok) {
            res(body);
          } else {
            req(body);
          }
        }
      })
      .catch(async (error) => {
        req(await error);
      });
  });
};

const postForm  = (endpoint, formData) => {
  return new Promise(async (res, req) => {
    const token = localStorage.getItem("HumayaDigital-Token");
    await fetch(`${URL}${endpoint}`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(async (result) => {
        if (result.status === 401) {
          swalWithBootstrapButtons
            .fire({
              icon: "warning",
              title: "SESION",
              text: "LA SESION A CADUCADO, FAVOR DE INICIAR SESION DE NUEVO",
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: "OK",
              reverseButtons: false,
            })
            .then(() => {
              window.location = "/auth/login";
            });
        } else {
          const body = await result.json();
          if (result.ok) {
            res(body);
          } else {
            req(body);
          }
        }
      })
      .catch(async (error) => {
        req(await error);
      });
  });
};
const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});
const get = (endpoint) => {
  return new Promise((res, req) => {
    const token = localStorage.getItem("HumayaDigital-Token");
    fetch(`${URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then(async (result) => {
        if (result.status === 401) {
          swalWithBootstrapButtons
            .fire({
              icon: "warning",
              title: "SESION",
              text: "LA SESION A CADUCADO, FAVOR DE INICIAR SESION DE NUEVO",
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: "OK",
              reverseButtons: false,
            })
            .then(() => {
              window.location = "/auth/login";
            });
        } else {
          const body = await result.json();
          if (result.ok) {
            res(body);
          } else {
            req(body);
          }
        }
      })
      .catch(async (error) => {
        req(await error);
      });
  });
};

const getBlob = (endpoint) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem("HumayaDigital-Token");

    fetch(`${URL}${endpoint}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(async (result) => {
        if (result.status === 401) {
          swalWithBootstrapButtons
            .fire({
              icon: "warning",
              title: "SESION",
              text: "LA SESION A CADUCADO, FAVOR DE INICIAR SESION DE NUEVO",
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: "OK",
              reverseButtons: false,
            })
            .then(() => {
              window.location = "/auth/login";
            });

          return;
        }

        const blob = await result.blob();

        if (result.ok) {
          resolve(blob);
        } else {
          reject(blob);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const request = {
  get: (endpoint) => get(endpoint),
  getBlob: (endpoint) => getBlob(endpoint),
  post: (endpoint, body) => post(endpoint, body),
  postToken: (endpoint, body, token) => postToken(endpoint, body, token),
  postForm: (endpoint, formData) => postForm(endpoint, formData),

};

export default request;
